// extracted by mini-css-extract-plugin
export var minWidthLimit = "w_9";
export var footerM = "w_dj";
export var footTop = "w_dk";
export var footTopDesc = "w_dl";
export var footTopText = "w_dm";
export var footLine = "w_dn";
export var footTopAddress = "w_dp";
export var footBottom = "w_dq";
export var downloadBar = "w_dr";
export var bd = "w_ds";
export var logo = "w_dt";
export var detail = "w_dv";
export var bigger = "w_dw";
export var red = "w_dx";
export var footBottomDesc = "w_dy";
export var ft = "w_dz";